export default function getUUId() {
    return (Date.now() + Math.random()).toString().replace('.', '-');
};